import { onMounted, onBeforeUnmount, ref } from 'vue'

/**
 * Estado reactivo de la conexión de red del navegador.
 *
 * Escucha los eventos `online`/`offline` de `window` y expone un ref
 * `online` que la UI observa (p. ej. para mostrar un banner).
 *
 * Es local a cada componente que lo usa; para un estado verdaderamente
 * global, lee el ref retornado en el composable raíz y lo pasas por
 * provide/inject o un store. En esta app basta con leerlo en App.vue.
 */
export function useOnlineStatus() {
  const online = ref(navigator.onLine)

  function update() {
    online.value = navigator.onLine
  }

  onMounted(() => {
    window.addEventListener('online', update)
    window.addEventListener('offline', update)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('online', update)
    window.removeEventListener('offline', update)
  })

  return { online }
}
